import { render, staticRenderFns } from "./werksInspection.vue?vue&type=template&id=dca2f9d6&scoped=true"
import script from "./werksInspection.vue?vue&type=script&lang=js"
export * from "./werksInspection.vue?vue&type=script&lang=js"
import style0 from "./werksInspection.vue?vue&type=style&index=0&id=dca2f9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca2f9d6",
  null
  
)

export default component.exports